import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type Toast = { id: number; message: string }
const initialState = {
  toasts: [] as Toast[],
  total: 0
}

export const eventSlice = createSlice({
  name: 'toast',
  initialState,
  reducers: {
    newToast(state, action: PayloadAction<string>) {
      state.total = state.total + 1
      state.toasts.push({
        id: state.total,
        message: action.payload
      })
    },
    toastsIndicated(state, action: PayloadAction<number[]>) {
      action.payload.forEach((id) => {
        state.toasts = state.toasts.filter((toast) => toast.id !== id)
      })
    }
  }
})

export const { newToast, toastsIndicated } = eventSlice.actions

export default eventSlice
